export const DISPLAY_DATE_TIME_FORMAT = 'M/D/YY @ hh:mma';
